import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    preferredData: [],
    loading: false,
    error: null,
};

const mutations = {
    SET_PREFERRED(state, data) {
        state.preferredData = data;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

const actions = {
    /**
     * Fetch preferred settings for an activity
     * @param {Object} context
     * @param {String|Number} activityId
     */
    async fetchPreferred({ commit }, activityId) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post("/manageactivityajax/", {
                cmd: "getpreferred",
                activityid: activityId,
            });

            const data = response.data || [];
            commit("SET_PREFERRED", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch preferred data");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    /**
     * Save user preferred settings for an activity
     * @param {Object} context
     * @param {Object} payload
     * @param {String|Number} payload.activityid
     * @param {Array<String|Number>} payload.useridsarray
     */
    async saveUserPreferred({ commit }, { activityid, useridsarray }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.post("/manageactivityajax/", {
                cmd: "saveuserpreferred",
                activityid,
                useridsarray,
            });

            const message = response.data?.message || "Preferences saved successfully";
            return { success: true, message };
        } catch (error) {
            const message = handleApiError(error, "Failed to save user preferences");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

const getters = {
    preferredData: (state) => state.preferredData,
    preferredLoading: (state) => state.loading,
    preferredError: (state) => state.error,
};

export default {
    state,
    mutations,
    actions,
    getters,
};